import { configureStore } from '@reduxjs/toolkit';
import { authService } from '../services/authService';
import reducers from './index';
import { userService } from '../services/userService';
import { chartService } from '../services/chartService';
import { projectService } from '../services/projectService';
import { companyService } from '../services/companyService';
import { areaService } from '../services/areaService';
import { depositService } from '../services/depositService';
import { fieldService } from '../services/fieldService';
import { horizonService } from '../services/horizonService';
import { layerService } from '../services/layerService';
import { reservoirService } from '../services/reservoirService';
import { wellService } from '../services/wellService';
import { chromatogramService } from '../services/chromatogramService';
import { reportService } from '../services/reportService';
import { minireportService } from '../services/miniportService';
import { researchObjectiveService } from '../services/researchObjectiveServices';
import { studiedPhaseService } from '../services/studiedPhaseService';
import { interpolationMapService } from '../services/interpolationMapService';
import { resultTableService } from '../services/resultTableService';
import { commentService } from '../services/commentService';
import { notificationService } from '../services/notoficationService';
import { lookupsService } from '../services/lookupsService';

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authService.middleware,
      userService.middleware,
      chartService.middleware,
      projectService.middleware,
      companyService.middleware,
      areaService.middleware,
      depositService.middleware,
      fieldService.middleware,
      horizonService.middleware,
      layerService.middleware,
      reservoirService.middleware,
      wellService.middleware,
      chromatogramService.middleware,
      reportService.middleware,
      minireportService.middleware,
      researchObjectiveService.middleware,
      studiedPhaseService.middleware,
      interpolationMapService.middleware,
      resultTableService.middleware,
      commentService.middleware,
      notificationService.middleware,
      lookupsService.middleware,
    ),
});

// Тип для всего состояния редакса
export type RootState = ReturnType<typeof store.getState>;

// Тип dispatch
export type AppDispatch = typeof store.dispatch;